import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

/**
 * Chakra UI カスタムテーマ設定
 * グラデーション・リッチなモダンデザインシステム
 */
const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        // ブランドカラー
        brand: {
          50: { value: '#e3f2fd' },
          100: { value: '#bbdefb' },
          200: { value: '#90caf9' },
          300: { value: '#64b5f6' },
          400: { value: '#42a5f5' },
          500: { value: '#2196f3' },
          600: { value: '#1e88e5' },
          700: { value: '#1976d2' },
          800: { value: '#1565c0' },
          900: { value: '#0d47a1' },
        },
        // グラデーション用カラー
        gradient: {
          blue: {
            start: { value: '#667eea' },
            end: { value: '#764ba2' },
          },
          purple: {
            start: { value: '#f093fb' },
            end: { value: '#f5576c' },
          },
          green: {
            start: { value: '#4facfe' },
            end: { value: '#00f2fe' },
          },
          orange: {
            start: { value: '#fa709a' },
            end: { value: '#fee140' },
          },
          teal: {
            start: { value: '#43e97b' },
            end: { value: '#38f9d7' },
          },
          pink: {
            start: { value: '#f6d365' },
            end: { value: '#fda085' },
          },
        },
      },
      shadows: {
        card: {
          value: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
        cardHover: {
          value:
            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        },
        button: {
          value: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
        buttonHover: {
          value: '0 4px 8px rgba(0, 0, 0, 0.15)',
        },
      },
      animations: {
        slideIn: {
          value: 'slideIn 0.2s ease-out',
        },
        fadeIn: {
          value: 'fadeIn 0.3s ease-in',
        },
      },
    },
    semanticTokens: {
      colors: {
        // 背景グラデーション
        'bg.gradient.blue': {
          value: {
            base: 'linear-gradient(135deg, {colors.gradient.blue.start} 0%, {colors.gradient.blue.end} 100%)',
          },
        },
        'bg.gradient.purple': {
          value: {
            base: 'linear-gradient(135deg, {colors.gradient.purple.start} 0%, {colors.gradient.purple.end} 100%)',
          },
        },
        'bg.gradient.green': {
          value: {
            base: 'linear-gradient(135deg, {colors.gradient.green.start} 0%, {colors.gradient.green.end} 100%)',
          },
        },
        'bg.gradient.orange': {
          value: {
            base: 'linear-gradient(135deg, {colors.gradient.orange.start} 0%, {colors.gradient.orange.end} 100%)',
          },
        },
        'bg.gradient.teal': {
          value: {
            base: 'linear-gradient(135deg, {colors.gradient.teal.start} 0%, {colors.gradient.teal.end} 100%)',
          },
        },
        'bg.gradient.pink': {
          value: {
            base: 'linear-gradient(135deg, {colors.gradient.pink.start} 0%, {colors.gradient.pink.end} 100%)',
          },
        },
        // サイドバー
        'sidebar.bg': {
          value: {
            base: '#ffffff',
            _dark: '#1a202c',
          },
        },
        'sidebar.border': {
          value: {
            base: '#e2e8f0',
            _dark: '#2d3748',
          },
        },
        'sidebar.item.hover': {
          value: {
            base: '#f7fafc',
            _dark: '#2d3748',
          },
        },
        'sidebar.item.active': {
          value: {
            base: '#ebf8ff',
            _dark: '#2c5282',
          },
        },
      },
    },
  },
  globalCss: {
    body: {
      bg: 'gray.50',
      color: 'gray.800',
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);
